import React from 'react';

export function ArrowRight(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.1437 0.749456C10.8499 0.473395 10.3891 0.457444 10.076 0.725812L10.0129 0.786105C9.7368 1.07994 9.72085 1.54075 9.98922 1.85385L12.857 5.19988H1.6125L1.5307 5.20401C1.1273 5.24498 0.8125 5.58567 0.8125 5.99988C0.8125 6.44171 1.17067 6.79988 1.6125 6.79988H12.857L9.98922 10.1459L9.93606 10.2152C9.70818 10.5478 9.7629 11.0056 10.076 11.274C10.4115 11.5615 10.9165 11.5226 11.204 11.1872L14.8322 6.95438L14.9063 6.86051C15.3015 6.31588 15.2768 5.56413 14.8322 5.04539L11.204 0.812585L11.1437 0.749456Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
